<template>

        <!-- Modal -->
        <div class="modal fade"  :class="{ show: false, 'd-block': false }"  id="userPortalModal"    aria-labelledby="userPortalModalLabel" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="max-height:30%; max-width: 80%;" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="userPortalModalLabel" v-if="this.view_type=='add'">Add User/Portal</h5>
                <h5 class="modal-title" id="userPortalModalLabel" v-else-if="this.view_type=='edit'">Edit User/Portal</h5>
                <h5 class="modal-title" id="userPortalModalLabel" v-else-if="this.view_type=='view'">View User/Portal</h5>
                <button type="button" ref="ref_userPortalModal" class="btn-close" :data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#userModal" aria-label="Close"></button>
            </div>
              <div v-if="this.view_type=='add' || this.view_type=='edit'">
              <form class="register-form" @submit.prevent="reg()">
            <div class="modal-body">

                <div class="card shadow-sm" id="stylized">
                   
                                <!-- <div class="card-body"> -->


                    <div class="card-body">
                      <h1>User Info</h1><br/>
                      <p></p>
        
                  <span>

                    <div class="row" style="margin-bottom:10px" v-if="app_portal=='MAIN' ||  app_portal=='DENOMINATION'">
                        <div class="col" v-if="app_portal=='MAIN'">
                                <label><span class="text_error">*</span>Denomination</label>
                             <div class="input-group">
                          
                         <v-select :options="getDenominations"  class="form-control select1" v-model="formData.denomination_id"  :reduce="denomination => denomination.id" label="denomination" @option:selected="denominationVal" />

                                                  
                        
                        </div>

                          <div
                            :class="{ text_error: denominationErr }"
                            v-if="denominationErr"
                          >
                            {{ denominationErr }}
                          </div>
                        </div>



                 
                      <div class="col" v-if="app_portal=='MAIN' || app_portal=='DENOMINATION'">
                                <label><span class="text_error">*</span>Church</label>
                             <div class="input-group">
                          

                         <v-select :options="getChurches" class="form-control select1" v-model="formData.church_id"  :reduce="church => church.id" label="church" @option:selected="churchVal" />

                                                  
                        
                        </div>

                          <div
                            :class="{ text_error: churchErr }"
                            v-if="churchErr"
                          >
                            {{ churchErr }}
                          </div>
                        </div>


                    </div>
                  
                    <div class="row" style="margin-bottom:10px">
                      <div class="col">
                        <label>Fullname</label>
                        <div class="input-group">
                          

                          <input
                            type="text"
                            class="form-control"
                            :class="{ form_error: fullnameErr}"
                            placeholder="Full Name"
                            @blur="fullnameVal($event.target.value)" 
                            v-model.trim="formData.fullname"
                          />
                         
                        </div>
                         <div
                            :class="{ text_error: fullnameErr  }"
                           v-if="fullnameErr">
                          {{ fullnameErr }} 
                          </div>
                      </div>






                         <div class="col">
                              <label>Gender</label>
                            <div class="input-group">
                          
                          <select
                            class="form-control"
                            :class="{ form_error: genderErr}"
                             @change="genderVal($event.target.value)"
                            v-model.trim="formData.gender">
                            <option value="">--Choose An Option--</option>
                            <option value="MALE">MALE</option>
                            <option value="FEMALE">FEMALE</option>
                          </select>
                          
                          
                        </div>
                        <div
                            :class="{ text_error: genderErr}"
                            v-if="genderErr"
                          >
                            {{ genderErr }}
                          </div>
                      </div>
                    </div>





                           <div class="row">
                          <div class="col">
                          <label><span class="text_error">*</span>Contact</label><br/>
                        <div class="input-group">
                          
               
                          <vue-tel-input   v-model.lazy="formData.contact" @blur="contactVal" ></vue-tel-input>
                          
                           

                        </div>
                        <div
                            :class="{ text_error: contactErr }"
                            v-if="contactErr"
                          >
                            {{ contactErr }}
                          </div>
                      </div>





                        <div class="col">
                        <label><span class="text_error">*</span>Email</label>
                        <div class="input-group">
                          
                          <input
                            type="email"
                            class="form-control"
                            :class="{ form_error: emailErr}"
                            placeholder="Email"
                            @blur="emailVal($event.target.value)"
                            v-model.trim.lazy="formData.email"
                          />
                         
                            
                        </div>
                         <div
                            :class="{ text_error: emailErr}"
                            v-if="emailErr"
                          >
                            {{ emailErr }} 
                          </div><br/>

                            
                      </div>


                    </div>



         
                
                  </span>
                




                      <span>
                        <h1>User Portal Info </h1><br/>
                      <p></p>
                    <div class="row" style="margin-bottom:10px">

                          <div class="col" v-if="app_portal=='MAIN' || app_portal=='DENOMINATION'">
                              <label>Portal</label>
                            <div class="input-group">
                          
                          <select
                            class="form-control"
                            :class="{ form_error: portalErr}"
                             @change="portalVal($event.target.value)"
                            v-model.trim="formData.portal"
                            v-if="app_portal=='MAIN'"
                            >
                            <option value="">--Choose An Option--</option>
                            <option value="MAIN">MAIN</option>
                            <option value="DENOMINATION">DENOMINATION</option>
                            <option value="CHURCH">CHURCH</option>
                          </select>


                            <select
                            class="form-control"
                            :class="{ form_error: portalErr}"
                             @change="portalVal($event.target.value)"
                            v-model.trim="formData.portal"
                            v-else-if="app_portal=='DENOMINATION'"
                            >
                            <option value="">--Choose An Option--</option>
                            <option value="DENOMINATION">DENOMINATION</option>
                            <option value="CHURCH">CHURCH</option>
                          </select>
                          
                          
                        </div>
                        <div
                            :class="{ text_error: portalErr}"
                            v-if="portalErr"
                          >
                            {{ portalErr }}
                          </div>
                      </div>



                      <div class="col" v-if="formData.portal=='DENOMINATION' && app_portal=='MAIN'">
                                <label><span class="text_error">*</span>Portal Denomination</label>
                             <div class="input-group">
                          
                         <v-select :options="getPortalDenominations"  class="form-control select1" v-model="formData.portal_denomination_id"  :reduce="denomination => denomination.id" label="denomination" @option:selected="portal_denominationVal" />

                                                  
                        
                        </div>

                          <div
                            :class="{ text_error: portal_denominationErr }"
                            v-if="portal_denominationErr"
                          >
                            {{ portal_denominationErr }}
                          </div>
                        </div>


                      <div class="col" v-if="formData.portal=='CHURCH' && (app_portal=='MAIN' || app_portal=='DENOMINATION')">
                                <label><span class="text_error">*</span>Portal Church</label>
                             <div class="input-group">
                          
                         <v-select :options="getPortalChurches"  class="form-control select1" v-model="formData.portal_church_id"  :reduce="church => church.id" label="church" @option:selected="portal_churchVal" />

                                                  
                        
                        </div>

                          <div
                            :class="{ text_error: portal_churchErr }"
                            v-if="portal_churchErr"
                          >
                            {{ portal_churchErr }}
                          </div>
                        </div>




                            <div class="col" v-if="formData.portal=='MAIN' || formData.portal=='DENOMINATION' || formData.portal=='CHURCH'">
                        <label>User Level </label>
                        <div class="input-group">
                          
                          <select
                            class="form-control"
                            :class="{ form_error: user_levelErr || 'user_level' in errorServers }"
                            @change="user_levelVal($event.target.value)"
                            v-model.trim="formData.user_level"
                            v-if="formData.portal=='MAIN'"
                            >
                            
                            <option value="" selected>--Choose An Option--</option>
                           <option value="SUPER ADMIN">SUPER ADMIN</option>
                            <option value="SECRETARY">SECRETARY</option>
                            <option value="MAIN DATA INPUTTER">MAIN DATA INPUTTER</option>
             
                          </select>

                                <select
                            class="form-control"
                            :class="{ form_error: user_levelErr || 'user_level' in errorServers }"
                            @change="user_levelVal($event.target.value)"
                            v-model.trim="formData.user_level"
                            v-else-if="formData.portal=='DENOMINATION'"
                            >
                            
                            <option value="" selected>--Choose An Option--</option>
                           <option value="DENOMINATION ADMIN">DENOMINATION ADMIN</option>
                            <option value="DENOMINATION SECRETARY">DENOMINATION SECRETARY</option>
                            <option value="DENOMINATION DATA INPUTTER">DENOMINATION DATA INPUTTER</option>
             
                          </select>


                           <select
                            class="form-control"
                            :class="{ form_error: user_levelErr || 'user_level' in errorServers }"
                            @change="user_levelVal($event.target.value)"
                            v-model.trim="formData.user_level"
                            v-else-if="formData.portal=='CHURCH'"
                            >
                            
                            <option value="" selected>--Choose An Option--</option>
                           <option value="CHURCH ADMIN">CHURCH ADMIN</option>
                            <option value="CHURCH SECRETARY">CHURCH SECRETARY</option>
                            <option value="CHURCH DATA INPUTTER">CHURCH DATA INPUTTER</option>
             
                          </select>
                          
                        </div>
                         <div :class="{ text_error: user_levelErr }" v-if="user_levelErr">
                            {{ user_levelErr }} 
                          </div>
                      </div>




                        

                    </div>






                       <div class="row">
                       <div class="col" v-if="!formData.user_portal_id">
                          <label><span class="text_error">*</span>Password</label>
                        <div class="input-group">
                          <input
                            v-bind:type="[showPassword ? 'text' : 'password']"
                            class="form-control"
                            :class="{ form_error: passwordErr }"
                            placeholder="Password"
                             @blur="passwordVal($event.target.value)"
                            v-model.trim="formData.password"
                          />
                              <i class="fa" @click="showPassword = !showPassword"   :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" style="margin-top:10px; margin-left:-30px; z-index:999;"  aria-hidden="true" ></i>
                         
                        </div>
                         <div
                            :class="{ text_error: passwordErr}"
                            v-if="passwordErr"
                          >
                            {{ passwordErr }}
                          </div>
                      </div>



                      <div class="col" v-if="!formData.user_portal_id">
                        <label><span class="text_error">*</span>Confirm Password</label>
                        <div class="input-group">
                          <input
                            v-bind:type="[showConfPassword ? 'text' : 'password']"
                            class="form-control"
                            :class="{ form_error: password_confirmationErr  }"
                            placeholder="Confirm Password"
                            @blur="password_confirmationVal($event.target.value)"
                            v-model.trim="formData.password_confirmation"
                          />
                           <i class="fa" @click="showConfPassword = !showConfPassword"   :class="[showConfPassword ? 'fa-eye' : 'fa-eye-slash']" style="margin-top:10px; margin-left:-30px; z-index:999;"  aria-hidden="true" ></i>

                    
                        </div>
                              <div
                            :class="{ text_error: password_confirmationErr }"
                            v-if="password_confirmationErr"
                          >
                            {{ password_confirmationErr }}
                          </div>
                      </div>




                       <div class="col">
                              <label>Is Active</label>
                            <div class="input-group">
                          
                          <select
                            class="form-control"
                            :class="{ form_error: is_activeErr}"
                             @change="is_activeVal($event.target.value)"
                            v-model.trim="formData.is_active">
                            <option value="">--Choose An Option--</option>
                            <option value="YES">YES</option>
                            <option value="NO">NO</option>
                          </select>
                          
                          
                        </div>
                        <div
                            :class="{ text_error: is_activeErr}"
                            v-if="is_activeErr"
                          >
                            {{ is_activeErr }}
                          </div>
                      </div>


                      
                    </div>
                   
                  </span>










                  
                </div>


                    

                                </div>
                
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" v-if="!user_idd && view_type=='add'">Submit</button>
                <button type="submit" class="btn btn-primary" v-if="view_type=='edit'">Update</button>
                <button type="submit" class="btn btn-primary" v-else-if="user_idd && view_type=='add'">Link</button>
                <button type="button" class="btn btn-danger" @click="remove_all" v-if="view_type=='add'">Clear All</button>
                <button type="button" class="btn btn-secondary" ref="UserPortalmodal_ref" data-bs-dismiss="modal" v-if="view_type=='edit'">Close</button>
            </div>

                  </form>
                  </div>


                 <div v-else>
                      <div class="modal-body">
                        <div class="table-responsive table-responsive-data2">
                        <table class="table table-hover table-striped">
                          
                              <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Value</th>
                                </tr>
                                </thead>


                                <tbody>
                       
                                <tr>
                                <td>Fullname</td>
                                <td>{{formData.fullname}}</td>
                                </tr>


                                <tr>
                                <td>Denomination</td>
                                <td>{{formData.denomination}}</td>
                                </tr>


                                <tr>
                                <td>Church</td>
                                <td>{{formData.church}}</td>
                                </tr>


                                <tr>
                                <td>Gender</td>
                                <td>{{formData.gender}}</td>
                                </tr>

                               <tr>
                                <td>Contact</td>
                                <td>{{formData.contact}}</td>
                                </tr>



                                <tr>
                                <td>Email</td>
                                <td>{{formData.email}}</td>
                                </tr>

                                <tr>
                                <td>Portal</td>
                                <td>{{formData.portal}}</td>
                                </tr>

                                <tr v-if="formData.portal=='DENOMINATION'">
                                <td>Portal Denomination</td>
                                <td>{{formData.portal_denomination}}</td>
                                </tr>

                                <tr v-if="formData.portal=='DENOMINATION' || formData.portal=='CHURCH'">
                                <td>Portal Church</td>
                                <td>{{formData.portal_church}}</td>
                                </tr>

                        
                                <tr>
                                <td>User Level</td>
                                <td>{{formData.user_level}}</td>
                                </tr>


                                <tr>
                                <td>Is Active</td>
                                <td>{{formData.is_active}}</td>
                                </tr>
                              </tbody>
                                  </table>


                                






                    
                        </div>

                      </div>

                 </div>




            </div>
        </div>


           



        
        </div>
</template>

<script>
 import axios from 'axios';
import FieldValidateService from "@/services/FieldValidateService";
import vSelect from 'vue-select';
import notificationBox from "@/services/notificationBox";
// import intlTelInput from 'intl-tel-input';
//import SpinnerComp from "@/components/SpinnerComp.vue";
import { mapMutations } from 'vuex';
import { LOADING } from '@/store/storeconstants';


    export default {

        name:'UserPortalModals',
        props:{
          view_type:{
            required:true,
            type: String
          },


   


          getUserPortalData:{
            required:true,
          }


        },


        components:{
        //  SpinnerComp,
          vSelect,
        },


           mounted(){



           },

        async created() {


   

   try{
       let response = await axios.get("getDenominations");
     // console.log(response.data.data);
     // response.data.data.unshift({id:"",country:"Please Select Option", created_at:null,updated_at:null})   
        this.getDenominations =  JSON.parse(JSON.stringify(response.data.data));
        this.getPortalDenominations =  JSON.parse(JSON.stringify(response.data.data));
        //console.log("meeeeeeee");
       
       
       
      
    }catch(error){
        console.log(error);
    }











 



this.getPortals();



  

 this.churchByDenomination();
  


        },




         data: function () {
    return {
      //userModal: null,
      is_existing_user: false,
      is_existing:"NO",
      app_portal: "",
      loading:false,
      getDenominations:[],
      getChurches:[],
      getPortalDenominations:[],
      getPortalChurches:[],
     // country_name:"",
      errorMess: "",
      succMess:"",
      SearcherrorServers:"",
      clear_user: true,
      clear_all: true,
      errorClient:[],
      errorServers:[],
      user_idd:"",
      found_data:false,
      has_password:false,
      showPassword: false,
      showConfPassword: false,


      modal:"modal",


   
      

      formData: {
        user_portal_id:"",
        portal:"",
        denomination_id:"",
        denomination:"",
        church_id:"",
        church:"",
        user_id:"",
       country:"",
       fullname:"",
       is_active:"",
       gender:"",
       contact:"",
       email:"",
       user_level:"",
       portal_denomination_id:"",
       portal_denomination:"",
       portal_church_id:"",
       portal_church:"",
       password:"",
       password_confirmation:"",


         },



    //Errors  
      fullnameErr: "",
      genderErr: "",
      countryErr: "",
      emailErr:"",
      user_levelErr:"",
      contactErr:"",
      passwordErr:"",
      password_confirmationErr:"",
      is_activeErr:"",
      portal_denominationErr:"",
      portal_churchErr:""










    };
    },


      methods: {

           ...mapMutations({
       showLoading:LOADING,
   }),


        async reg(){

    
        
   
           this.showLoading(true); 
    
      this.errorServers = [];
       this.errorClient = [];
      
       this.denominationVal(this.formData.denomination_id);
       this.churchVal(this.formData.church_id);
       this.fullnameVal(this.formData.fullname);
       this.genderVal(this.formData.gender);
       this.contactVal(this.formData.contact);
       this.emailVal(this.formData.email);
       this.portalVal(this.formData.portal);
       this.user_levelVal(this.formData.user_level);
       this.passwordVal(this.formData.password);
       this.password_confirmationVal(this.formData.password_confirmation);
       this.is_activeVal(this.formData.is_active);
       this.is_activeVal(this.formData.is_active);
       this.portal_denominationVal(this.formData.portal_denomination_id);
       this.portal_churchVal(this.formData.portal_church_id);

       if(this.errorClient.length > 0){

            this.showLoading(false);
          notificationBox.errorNotifications("Some Errors Exist");
        //  console.log(this.errorClient);
          return true;

       }
       else{

            if(this.view_type == "add"){

            try{
            const response = await axios.post("user_portals",this.formData);
            if(response.status == 200)
            {
                 this.showLoading(false);

                     this.clearFormData();
                  notificationBox.succNotifications("User/ User Portal Added Successfully");
                  this.$emit("user_portalAdded");
            }
        }catch(error){

             console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);
          

                  if(this.errorServers.length > 0)
       {
           notificationBox.errorNotifications("Some Errors Exist");
            this.getServerError();
     
       }
           else if(error.response.data.data_error){
           notificationBox.errorNotifications(error.response.data.data_error);
       }

        }

       }






      else if(this.view_type=="edit")
      {

                   try{
            const response = await axios.patch(`user_portals/${this.formData.user_portal_id}`,this.formData);
            if(response.status == 200)
            {
                 this.showLoading(false);

                     
                  notificationBox.succNotifications("User/ User Portal Edited Successfully");
                  this.$emit("user_portalAdded");
                  this.clearFormData();
                  this.$refs.UserPortalmodal_ref.click();

            }
        }catch(error){

             //console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);
          

                  if(this.errorServers.length > 0)
       {
           notificationBox.errorNotifications("Some Errors Exist");
            this.getServerError();
     
       }
            else if(error.response.data.data_error){
           notificationBox.errorNotifications(error.response.data.data_error);
       }

        }
      


      }


       }



      
        },




        getServerError(){

        this.denominationErr = 'denomination_id' in this.errorServers[0] ? this.errorServers[0].denomination_id[0] : '';
       this.churchErr = 'church_id' in this.errorServers[0] ? this.errorServers[0].church_id[0] : '';
       this.fullnameErr = 'fullname' in this.errorServers[0] ? this.errorServers[0].fullname[0] : '';
       this.genderErr = 'gender' in this.errorServers[0] ? this.errorServers[0].gender[0] : '';
       this.contactErr = 'contact' in this.errorServers[0] ? this.errorServers[0].contact[0] : '';
       this.emailErr = 'email' in this.errorServers[0] ? this.errorServers[0].email[0] : '';
       this.portalErr = 'portal' in this.errorServers[0] ? this.errorServers[0].portal[0] : '';
      this.user_levelErr = 'user_level' in this.errorServers[0] ? this.errorServers[0].user_level[0] : '';
      this.passwordErr = 'password' in this.errorServers[0] ? this.errorServers[0].password[0] : '';
      this.password_confirmationErr = 'password_confirmation' in this.errorServers[0] ? this.errorServers[0].password_confirmation[0] : '';
      this.is_activeErr = 'is_active' in this.errorServers[0] ? this.errorServers[0].is_active[0] : '';
      this.portal_denominationErr = 'portal_denomination_id' in this.errorServers[0] ? this.errorServers[0].portal_denomination_id[0] : '';
      this.portal_churchErr = 'portal_church_id' in this.errorServers[0] ? this.errorServers[0].portal_church_id[0] : '';


     
           return true;
           
        },




        clearFormData(){


              this.errorServers = [];
        this.errorClient = [];
      //this.clear_user = false;
      this.formData.denomination = "";
      this.formData.denomination_id = "";
      this.formData.church = "";
      this.formData.church_id = "";
      this.formData.fullname = "";
      this.formData.gender = "";
      this.formData.contact = "";
      this.formData.email = "";
      this.formData.portal = "";
      this.formData.user_level = "";
      this.formData.password = "";
      this.formData.password_confirmation = "";
      this.formData.is_active = "";
      this.formData.portal_denomination_id = "";
      this.formData.portal_denomination = "";
      this.formData.portal_church_id = "";
      this.formData.portal_church = "";
      this.formData.is_active = "";
      this.denominationErr = "";
      this.churchErr = "";
      this.fullnameErr = "";
      this.genderErr = "";
      this.contactErr = "";
      this.emailErr = "";
      this.portalErr = "";
      this.user_levelErr = "";
      this.passwordErr = "";
      this.password_confirmationErr = "";
      this.is_activeErr = "";

      this.getPortals();


       
        },


// Get Church By Denomination

async churchByDenomination(){
    try{

        const response = await axios.get(`getChurchByDenomination?denomination_id=${this.formData.denomination_id}`)
        this.getChurches = response.data.data;

       // console.log(this.getChurches);

    }catch(_){

        console.log(_);

    }
},

//////// form verification ///////////



 denominationVal(value){

   //  let max = 499;
      let field = "Denomination";
     
     if(this.app_portal=="MAIN" && FieldValidateService.reqVal(value,field))
     {
       this.denominationErr = FieldValidateService.reqVal(value,field);
        this.errorClient.push(this.denominationErr);
     }else{

           if(this.errorClient.includes(this.denominationErr))
           {
            let pos = this.errorClient.indexOf(this.denominationErr);
           this.errorClient.splice(pos,1);
            this.denominationErr =""; 
            
           }
          
          this.churchByDenomination();
          

     }

   },









  
   portal_denominationVal(value){

   //  let max = 499;
      let field = "Portal Denomination";
     
     if(this.formData.portal=="DENOMINATION" && FieldValidateService.reqVal(value,field))
     {
       this.portal_denominationErr = FieldValidateService.reqVal(value,field);
        this.errorClient.push(this.portal_denominationErr);
     }else{

           if(this.errorClient.includes(this.portal_denominationErr))
           {
            let pos = this.errorClient.indexOf(this.portal_denominationErr);
           this.errorClient.splice(pos,1);
            this.portal_denominationErr =""; 
            
           }
          
          //this.churchByDenomination();
          

     }

   },








      portal_churchVal(value){

   //  let max = 499;
      let field = "Portal Church";
     
     if(this.formData.portal=="CHURCH" && FieldValidateService.reqVal(value,field))
     {
       this.portal_churchErr = FieldValidateService.reqVal(value,field);
        this.errorClient.push(this.portal_churchErr);
     }else{

           if(this.errorClient.includes(this.portal_churchErr))
           {
            let pos = this.errorClient.indexOf(this.portal_churchErr);
           this.errorClient.splice(pos,1);
            this.portal_churchErr =""; 
            
           }
          
          //this.churchByDenomination();
          

     }

   },







    churchVal(value){

   //  let max = 499;
      let field = "Church";
     
     if((this.app_portal=="MAIN" || this.app_portal=="DENOMINATION") && FieldValidateService.reqVal(value,field))
     {
       this.churchErr = FieldValidateService.reqVal(value,field);
        this.errorClient.push(this.churchErr);
     }else{

           if(this.errorClient.includes(this.churchErr))
           {
            let pos = this.errorClient.indexOf(this.churchErr);
           this.errorClient.splice(pos,1);
            this.churchErr =""; 
           }
          
          

     }

   },





 fullnameVal(value){

     let max = 499;
      let field = " Full name";
     
     if(FieldValidateService.reqMaxStringVal(value,field,max))
     {
       this.fullnameErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.fullnameErr);
     }else{

           if(this.errorClient.includes(this.fullnamelErr))
           {
            let pos = this.errorClient.indexOf(this.fullnameErr);
           this.errorClient.splice(pos,1);
            this.fullnameErr =""; 
           }
          
           this.fullnameErr =""; 

     }

   },




    genderVal(value){

     let max = 50;
      let field = "Gender";
     
     if(FieldValidateService.reqMaxStringVal(value,field,max))
     {
       this.genderErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.genderErr);
     }else{

           if(this.errorClient.includes(this.genderErr))
           {
            let pos = this.errorClient.indexOf(this.genderErr);
           this.errorClient.splice(pos,1);
            this.genderErr =""; 
           }
          
          

     }

   },


   
        contactVal(){

            let field = "Contact"

           let value = this.formData.contact;

         if(FieldValidateService.reqValNum(value, field))
     {
       this.contactErr = FieldValidateService.reqValNum(value, field);
        this.errorClient.push(this.contactErr);
     }else{

          if(this.errorClient.includes(this.contactErr))
        {
        let pos = this.errorClient.indexOf(this.contactErr);
        this.errorClient.splice(pos,1);
        }
           this.contactErr =""; 

      
          

     }

    },


   
      

       emailVal(value){


                 let field = "Email"

         if(FieldValidateService.reqValEmail(value, field))
     {
       this.emailErr = FieldValidateService.reqValEmail(value,field);
        this.errorClient.push(this.emailErr);
     }else{

          if(this.errorClient.includes(this.contactErr))
        {
        let pos = this.errorClient.indexOf(this.contactErr);
        this.errorClient.splice(pos,1);
        }
           this.emailErr =""; 
      
         

     }


    },



   
        user_levelVal(value){

     let max = 100;
      let field = "User level";
     
     if(FieldValidateService.reqMaxStringVal(value,field,max))
     {
       this.user_levelErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.user_levelErr);
     }else{

           if(this.errorClient.includes(this.user_levelErr))
           {
            let pos = this.errorClient.indexOf(this.user_levelErr);
           this.errorClient.splice(pos,1);
            this.user_levelErr =""; 
           }
          
          

     }

   },





  is_activeVal(value){

     let max = 10;
      let field = "Is Active";
     
     if(FieldValidateService.reqMaxStringVal(value,field,max))
     {
       this.is_activeErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.is_activeErr);
     }else{

           if(this.errorClient.includes(this.is_activeErr))
           {
            let pos = this.errorClient.indexOf(this.is_activeErr);
           this.errorClient.splice(pos,1);
            this.is_activeErr =""; 
           }
          
          

     }

   },





   portalVal(value){

   //  let max = 499;
      let field = " Portal";
     
     if(FieldValidateService.reqVal(value,field))
     {
       this.portalErr = FieldValidateService.reqVal(value,field);
        this.errorClient.push(this.portalErr);
     }else{

           if(this.errorClient.includes(this.portalErr))
           {
            let pos = this.errorClient.indexOf(this.portalErr);
           this.errorClient.splice(pos,1);
            this.portalErr =""; 
            //this.churchByDenomination();
           }
          
          

     }

   },






   


    passwordVal(value){

    //  let max = 19;
      let field = "Password";
     
     if(FieldValidateService.reqValPassword(value,field))
     {
       this.passwordErr = FieldValidateService.reqValPassword(value,field);
        this.errorClient.push(this.passwordErr);
     }else{

           if(this.errorClient.includes(this.passwordErr))
           {
            let pos = this.errorClient.indexOf(this.passwordErr);
           this.errorClient.splice(pos,1);
            this.passwordErr =""; 
           }
          
          

     }

   },


    


     password_confirmationVal(value){

           
          

      if(FieldValidateService.valPasswordConfirm(value, this.formData.password))
     {
       this.password_confirmationErr = FieldValidateService.valPasswordConfirm(value,this.formData.password);
        this.errorClient.push(this.password_confirmationErr);
     }else{

            if(this.errorClient.includes(this.password_confirmationErr))
        {
        let pos = this.errorClient.indexOf(this.password_confirmationErr);
        this.errorClient.splice(pos,1);
        }
           this.password_confirmationErr =""; 

     }


   },



   async getPortals(){
    
if(Array.isArray(JSON.parse(localStorage.getItem("user_portal_info")))) {
   this.app_portal = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal;
    this.formData.portal = this.app_portal;
 if(this.app_portal == "CHURCH")
 {
// this.formData.church_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church_id;
// this.formData.portal_church_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church_id;
// this.formData.church = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church;

this.formData.church_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church_id;
this.formData.denomination_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_denomination_id;
this.formData.portal_church_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church_id;
this.formData.portal_denomination_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_denomination_id;
this.formData.church = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church;
 }
  else if(this.app_portal == "DENOMINATION")
 {
  this.formData.denomination_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_denomination_id;
  this.formData.portal_denomination_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_denomination_id;
  this.formData.denomination = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_denomination;

     try{
       let response = await axios.get(`getChurchByDenomination?denomination_id=${this.formData.portal_denomination_id}`);
     // console.log(response.data.data);
     // response.data.data.unshift({id:"",country:"Please Select Option", created_at:null,updated_at:null})   
        this.getPortalChurches =  JSON.parse(JSON.stringify(response.data.data));
        //console.log("meeeeeeee");
    
      
    }catch(error){
        console.log(error);
    }

 }
 else{
       try{
       let response = await axios.get("getChurches");
     // console.log(response.data.data);
     // response.data.data.unshift({id:"",country:"Please Select Option", created_at:null,updated_at:null})   
        this.getPortalChurches =  JSON.parse(JSON.stringify(response.data.data));
        //console.log("meeeeeeee");
    
      
    }catch(error){
        console.log(error);
    }
 }
}
else{


   this.app_portal = JSON.parse(localStorage.getItem("user_portal_info")).portal;
 if(this.app_portal == "CHURCH")
 {
this.formData.church_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_church_id;
this.formData.denomination_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_denomination_id;
this.formData.portal_church_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_church_id;
this.formData.portal_denomination_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_denomination_id;
this.formData.church = JSON.parse(localStorage.getItem("user_portal_info")).portal_church;
 }
  else if(this.app_portal == "DENOMINATION")
 {
  this.formData.denomination_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_denomination_id;
  this.formData.portal_denomination_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_denomination_id;
  this.formData.denomination = JSON.parse(localStorage.getItem("user_portal_info")).portal_denomination;

       try{
       let response = await axios.get(`getChurchByDenomination?denomination_id=${this.formData.portal_denomination_id}`);
     // console.log(response.data.data);
     // response.data.data.unshift({id:"",country:"Please Select Option", created_at:null,updated_at:null})   
        this.getPortalChurches =  JSON.parse(JSON.stringify(response.data.data));
        //console.log("meeeeeeee");
    
      
    }catch(error){
        console.log(error);
    }
 }

  else{
       try{
       let response = await axios.get("getChurches");
     // console.log(response.data.data);
     // response.data.data.unshift({id:"",country:"Please Select Option", created_at:null,updated_at:null})   
        this.getPortalChurches =  JSON.parse(JSON.stringify(response.data.data));
        //console.log("meeeeeeee");
    
      
    }catch(error){
        console.log(error);
    }
 }

}

   }
      

  






 





      },


    //    computed:{

    //     changes : {
    //         get : function(){
    //             return this.count_down;
    //         },
    //         set : function(vem){
             
    //             this.count_down =  vem;
    //              if(this.count_down <= 0){
    //             this.count_down = "";
    //              clearInterval(this.count_down);
    //           }
    //         }
    //     }
    // },

 


      watch:{
           view_type(value){

           if(value == "add")
           {
             this.clearFormData();
            
           }

          

        },

     


           async getUserPortalData(value){
            const data = value;

          console.log(data);

             this.formData.user_id = data.user_id;
             this.formData.user_portal_id = data.id;
            this.formData.portal = data.portal;
            this.formData.denomination_id = data.denomination_id;
            this.formData.denomination = data.denomination;
              this.churchByDenomination();
            this.formData.church_id = data.church_id;
            this.formData.church = data.church;
            this.formData.fullname = data.fullname;
            this.formData.gender = data.gender;
            this.formData.contact = data.contact;
            this.formData.email = data.email;
            this.formData.password = data.password;
            this.formData.password_confirmation = data.password;
            this.formData.user_level = data.user_level;
            this.formData.is_active = data.is_active;
            this.formData.portal_denomination_id = data.portal_denomination_id;
            this.formData.portal_denomination = data.portal_denomination;
            this.formData.portal_church_id = data.portal_church_id;
            this.formData.portal_church = data.portal_church;
        



          }
      }
        
    }
</script>

<style scoped>


</style>